import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

export const StyledRedirectButton = styled.a`
  display: block;

  padding-block: 10px;
  padding-inline: 20px;

  color: #001246;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
  text-align: center;
  text-decoration: none;

  border-radius: 3px;

  background-color: #ffca05;

  cursor: pointer;
`;
